import { History, RotateCcw } from "lucide-react";

const fmt = (stamp) => {
  const m = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/.exec(stamp);
  return m ? new Date(Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5], +m[6])).toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" }) : stamp;
};

export function BackupsPanel({ backups, onRestore, busy }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-testid="admin-backups">
      <div className="flex items-center gap-2">
        <History className="h-5 w-5 text-slate-500" />
        <h3 className="font-heading text-base font-semibold text-slate-900">Version history</h3>
      </div>
      <p className="mt-1 text-xs text-slate-500">A backup is taken before every save. Restoring also creates a backup of the current rules.</p>
      {backups.length === 0 ? (
        <p className="mt-4 text-sm text-slate-400">No backups yet.</p>
      ) : (
        <ul className="mt-4 divide-y divide-slate-100">
          {backups.map((b) => (
            <li key={b.name} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-testid={`admin-backup-${b.saved_at}`}>
              <div>
                <p className="font-medium text-slate-800">{fmt(b.saved_at)}</p>
                <p className="font-mono-tech text-xs text-slate-400">{b.version || "—"}</p>
              </div>
              <button onClick={() => onRestore(b.name)} disabled={busy} data-testid={`admin-restore-${b.saved_at}`}
                className="inline-flex items-center gap-1 rounded-md border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50">
                <RotateCcw className="h-3.5 w-3.5" /> Restore
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
